import { render, staticRenderFns } from "./FeatUserAddedPanel.vue?vue&type=template&id=4becb846"
import script from "./FeatUserAddedPanel.vue?vue&type=script&lang=js"
export * from "./FeatUserAddedPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports